import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';

const Jard_table = () => {
    const { initState } = useContext(GlobalContext); 
    return (
        <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-around px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">کۆی بەهای کۆگا</h2>
                    <h2 className="text-base font-semibold text-slate-800">{numberbeautify(money_rounding(initState?.total_stock_price))} $</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          ناوی کاڵا
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          کۆد
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          نرخ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          بڕی ماوە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          کۆ
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.stok.map((lis)=>(
                        <tr key={lis.item_id} className={Number(lis.item_qty)==0?"bg-red-400":Number(lis.item_min_notification) < Number(lis.item_qty)?"bg-white":"bg-yellow-300"}>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {lis.item_name}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {lis.item_barcode}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {numberbeautify(lis.item_price)}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {/* {lis.item_unit_one} {Math.floor(lis.item_qty)}/{Math.round((Number(lis.item_qty)-Number(Math.floor(lis.item_qty)))*lis.item_unit_one_of_many)} {lis.item_unit_many}  */}
                                {lis.item_unit_one} {money_rounding(Math.floor(lis.item_qty/lis.item_unit_one_of_many))}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {numberbeautify(money_rounding(lis?.cost_per_item))} $
                          </td>
                        </tr>
                        ))}
                    </tbody>
              </table>
            </div>
          </div>
    )
}

export default Jard_table